<template>
  <div class="staff-basic">
    <c-table
      ref="table"
      :fields="fields"
      :columns="columns"
      url="/mailbackup/home"
    >
    <el-table-column slot="email" label="邮箱">
      <template v-slot="{row}">
        <el-button type="text" @click="goToDetail(row)">{{row.email}}</el-button>
      </template>
    </el-table-column>
    </c-table>
  </div>
</template>

<script>
import CTable from '@/components/common/table'
import mixin from '@/mixins'

export default {
  name: 'mail',
  mixins: [ mixin ],
  components: { CTable },
  data () {
    return {
      fields: [{
        prop: 'search',
        placeholder: '搜索姓名或邮箱',
        clearable: true
      }],
      columns: [
        { slot: 'email' },
        { prop: 'name', label: '姓名' }
      ]
    }
  },
  methods: {
    goToDetail (row) {
      this.$router.push(`/backup/email/${row.email}`)
    }
  }
}
</script>

<style lang="scss">
</style>
